import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonService } from 'src/app/provide/common.service';

@Component({
    selector: 'deals-layout-service',
    templateUrl: './deals-layout-service.component.html',
    styleUrls: ['./deals-layout-service.component.scss'],
    standalone: false
})
export class DealsLayoutServiceComponent implements OnInit {
  @Input() data : any
  @Input() countDown : any
  @Input() showEdit : boolean
  @Output() on_Click = new EventEmitter
  @Output() on_Click_Edit = new EventEmitter
  isLoaded: boolean = false;
  
  constructor(private commonService:CommonService) { }

  ngOnInit(): void {
  
  }
  dealVIEw(e){
    this.on_Click.emit(e)
  }
  getPrice(e: any) {

    return this.commonService.getPrice(e)
  }
  onEdit(e){
    this.on_Click_Edit.emit(e)
  }
  onImageLoad(){
    this.isLoaded = true
  }
}
